import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Ensure CSS variable --nav-height matches the actual navbar height at runtime.
// This avoids layout drift due to font/zoom differences and guarantees the
// hero centering math uses the true header height.
function syncNavHeight() {
  try {
    const nav = document.querySelector('.navbar');
    if (!nav) return;
    const h = nav.offsetHeight;
    document.documentElement.style.setProperty('--nav-height', `${h}px`);
  } catch (e) {
    // ignore in non-browser environments
  }
}

// Run on load and update on resize/orientation change
window.addEventListener('load', syncNavHeight);
window.addEventListener('resize', syncNavHeight);
// run once now in case load already fired
syncNavHeight();
